export default "__VITE_ASSET__QleYzdrK__"